import React from "react";
import styled from "styled-components";

export const H4 = styled.h4`
    /* MODAL SUBTITLE */
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--secondary-foreground);
`;
